import styled from "styled-components";
import { primaryColor } from "utils/variable";

export const GlobalStyle = styled.div`
  .App {
    overflow: hidden;
  }

  p {
    margin: 0;
  }

  .ant-btn-primary {
    height: 40px;
    background-color: ${primaryColor};

    &:hover {
      height: 40px;
      background-color: ${primaryColor};
    }
  }
`;
